import { todoCardIds } from '../../../../pages/home-page/version2/todo-cards/todo-card-ids';
import { CountryConfigNames } from '../../country-config-enums';
import { CountryUIFeature } from '../country-ui-feature';
import { CountryUIConfigName } from '../constants';

export const CACountryUIConfig = [
  new CountryUIFeature(CountryConfigNames.FTUWizardHiddenTodoCards, {
    todoCardIds: [todoCardIds.FULFILLMENT],
  }),
  // TODO: [SPD-26173] Remove once enableExpandedTaxIdCountries is fully rolled out
  new CountryUIFeature(CountryUIConfigName.TaxIdUIOverride, {
    isTaxIdAvailable: 'false',
  }),
];
